import { NewsType } from '@domains/news';
import { NewsListPageProps, WithGlobalData } from '@domains/view';

import { BFFCookieClientClass } from '@api/client/bff';
import { NewsListPayload, NewsListResult } from '@api/protocol';

import { DEFAULT_PAGE_SIZE } from '@utils/constants';
import { isPageOutOfRange } from '@utils/pagination';
import { parsePositiveInt } from '@utils/query';

import { News } from '@views/News/News';

type QueryParams = {
    page?: QueryParam;
    type?: QueryParam;
};

const newsTypes: Record<NewsType, true> = {
    news: true,
    promotion: true,
};

const isNewsType = (value: string): value is NewsType =>
    Object.prototype.hasOwnProperty.call(newsTypes, value);

export const getServerSideProps: BFF.GetPageServerSideProps<
    WithGlobalData<NewsListPageProps>,
    QueryParams
> = async (context) => {
    const { req, query } = context;

    const page = parsePositiveInt(query.page) ?? 1;
    const typeParam = query.type;
    let type: NewsType | undefined;

    if (typeParam === undefined || typeParam === '') {
        type = undefined;
    } else if (typeof typeParam === 'string' && isNewsType(typeParam)) {
        type = typeParam;
    } else {
        return { notFound: true };
    }

    const result = await BFFCookieClientClass<NewsListPageProps>({
        request: req,
        isNotFoundOnErrorShown: true,
    })
        .addToStack<NewsListPayload, NewsListResult>({
            prop: 'data',
            url: '/api/news/list',
            payload: { type, page, per_page: DEFAULT_PAGE_SIZE },
        })
        .getServerProps();

    if ('props' in result && 'data' in result.props) {
        const { total, page_size } = result.props.data;
        if (isPageOutOfRange(page, total, page_size)) {
            return { notFound: true };
        }
    }

    return result;
};

export default News;
